import React from "react";
import "./Header_Banner.css";
import Breadcrumb_comp from "../../breadcrumb-comp/Breadcrumb_Comp";

const Header_Banner = ({ imgSrc, title_text, breadcrumbs = [] }) => {
  return (
    <section className="Common_Banner">
      <div className="img_holder">
        <img src={imgSrc} className="banner_img" />
      </div>
      <div className="overlay_colour"></div>
      <div className="container ">
        <div className="content_div">
          <div className="breadcrump_div">
            <Breadcrumb_comp breadcrumbs={breadcrumbs} />
          </div>
          <p className="title_text">{title_text}</p>
        </div>
      </div>
    </section>
  );
};

export default Header_Banner;
